export const ColumnIds = {
  name: 'name',
  displayOrder: 'displayOrder',
} as const;
export type ColumnIds = (typeof ColumnIds)[keyof typeof ColumnIds];
